/** Mirrors Server Enums.JournalEntryTypes */
export const JournalEntryTypes = {
  NormalJournal: 0,
  IsDepreciationJournal: 1,
  AdditionalJournalCommands: 2,
  VehicleManagement: 3,
  VatClosing: 4,
  PayrollJournal: 5,
};

export const JOURNAL_ENTRY_TYPE_OPTIONS = [
  { value: JournalEntryTypes.NormalJournal, label: 'NormalJournal' },
  { value: JournalEntryTypes.IsDepreciationJournal, label: 'IsDepreciationJournal' },
  { value: JournalEntryTypes.AdditionalJournalCommands, label: 'AdditionalJournalCommands' },
  { value: JournalEntryTypes.VehicleManagement, label: 'VehicleManagementJournal' },
  { value: JournalEntryTypes.VatClosing, label: 'VatClosing' },
  { value: JournalEntryTypes.PayrollJournal, label: 'PayrollJournal' },
];

export function journalEntryTypeLabel(type, t) {
  const v = type ?? JournalEntryTypes.NormalJournal;
  if (v === JournalEntryTypes.IsDepreciationJournal) return t('IsDepreciationJournal');
  if (v === JournalEntryTypes.AdditionalJournalCommands) return t('AdditionalJournalCommands');
  if (v === JournalEntryTypes.VehicleManagement) return t('VehicleManagementJournal');
  if (v === JournalEntryTypes.VatClosing) return t('VatClosing');
  if (v === JournalEntryTypes.PayrollJournal) return t('PayrollJournal');
  return t('NormalJournal');
}
